import { QueueAssetSyncRequest } from '@beable/roster-backend-client-v1';
import { Box, Button, FormControl, TextField, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { useState } from 'react';
import RosterBackendService from '../../services/RosterBackendService';
import { getStyles } from './styles';

const regexExp =
  /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;

export default function AssetSync({ onSuccess }: { onSuccess: () => void }) {
  const theme = useTheme();
  const styles = getStyles(theme);

  const [assetId, setAssetId] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = async (
    event,
  ) => {
    event.preventDefault();
    setIsLoading(true);
    if (!assetId.length) {
      setErrorMessage('You must enter in an asset ID before submitting.');
      setIsLoading(false);
      return;
    }
    if (!regexExp.test(assetId)) {
      setErrorMessage('Invalid Asset Id! Please try again!');
      setIsLoading(false);
      return;
    }

    const request: QueueAssetSyncRequest = {
      assetId: assetId,
    };

    const response = await RosterBackendService.queueAssetSync(request);

    if (response.isOk()) {
      setIsLoading(false);
      onSuccess();
      return;
    }
    setErrorMessage(
      'We’re sorry but this is not a valid Beable Asset ID. Please re-copy and paste the full ID.',
    );
    setTimeout(() => {
      setIsLoading(false);
    }, 100);
    return;
  };

  return (
    <form data-testid='form' onSubmit={handleSubmit}>
      <FormControl component="fieldset" disabled={isLoading} sx={styles.fieldSetStyle}>
        <Typography variant='body2' sx={{ marginBottom: '8px' }}>
          You can provide the same asset ID multiple times if the alignment is
          updated.
        </Typography>
        <TextField
          error={!!errorMessage}
          id='assetIdInput'
          name='assetIdInput'
          label='Asset Id'
          variant='outlined'
          fullWidth
          helperText={errorMessage}
          autoFocus
          onChange={(e) => {
            setAssetId(e.target.value);
            if (
              (errorMessage && regexExp.test(e.target.value)) ||
              !e.target.value.length
            ) {
              setErrorMessage('');
            }
          }}
        />
        <Box sx={styles.button}>
          <Button
            type='submit'
            variant='contained'
            color='primary'
            disabled={!assetId.length || isLoading}
          >
            Submit
          </Button>
        </Box>
      </FormControl>
    </form>
  );
}
